import { render } from "./ContactWarning.vue?vue&type=template&id=6a48a1b0&scoped=true"
import script from "./ContactWarning.vue?vue&type=script&lang=js"
export * from "./ContactWarning.vue?vue&type=script&lang=js"

import "./ContactWarning.vue?vue&type=style&index=0&id=6a48a1b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a48a1b0"]])

export default __exports__